import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { LogoutService } from './logout.service';
import { IWebSocketService } from '@insight/services';

@Component({
	selector: 'app-logout',
	template: ''
})
export class LogoutComponent implements OnInit {

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private location: Location,
		private logoutService: LogoutService,
		private webSocketService: IWebSocketService
	) { }

	ngOnInit() {
		const returnUrl = this.route.snapshot.queryParams.returnUrl || '';
		console.log('returnUrl', returnUrl);
		this.logoutService.logout();
		this.webSocketService.close();
		// this.webSocketService.reconnect();
		this.router.navigateByUrl(returnUrl);
	}

}
